var _linearGradient, _linearGradient2, _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 414,
    height: 735,
    viewBox: "0 0 414 735",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_863",
    "data-name": "Rectangle 863",
    width: 414,
    height: 735,
    transform: "translate(0 1)",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#effaf8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3f2e1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbf4e7"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 415,
    height: 743,
    transform: "translate(-1)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_55",
    "data-name": "Mask Group 55",
    transform: "translate(0 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4869",
    "data-name": "Group 4869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16638",
    "data-name": "Path 16638",
    d: "M0,0H415V736H0Z",
    transform: "translate(-1)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4845",
    "data-name": "Group 4845",
    transform: "translate(7.119 376.5)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    "data-name": "Rectangle 792",
    width: 15.547,
    height: 230.51,
    transform: "translate(63.104 80.278)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16675",
    "data-name": "Path 16675",
    d: "M653.868,1836.895v-14.633H649.8v-21.848h-6.3v-9.348h-37.5v31.2h-1.829v211.1h62.19V1836.895Z",
    transform: "translate(-604.177 -1722.576)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16676",
    "data-name": "Path 16676",
    d: "M790.676,1685.925h-56.9V1740h0V1993.27h69.506V1700.416Z",
    transform: "translate(-652.659 -1682.483)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16677",
    "data-name": "Path 16677",
    d: "M890.253,1946.606v-45.727H874.2V1797.636H857.583v103.243H849.4v134.99h52.841v-89.262Z",
    transform: "translate(-696.003 -1725.081)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16678",
    "data-name": "Path 16678",
    d: "M985.691,1726.394a19.1,19.1,0,0,0-18.489-18.488v-27.544h-2.439v27.605a19.115,19.115,0,0,0-17.27,18.427H942.2v264.755h47.252V1726.394Z",
    transform: "translate(-730.79 -1680.361)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    "data-name": "Rectangle 793",
    width: 45.931,
    height: 242.297,
    transform: "translate(260.609 68.49)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16679",
    "data-name": "Path 16679",
    d: "M1144.168,1758.81a22.549,22.549,0,0,0-19.711-22l-3.249-30.328-3.25,30.328a22.548,22.548,0,0,0-19.712,22h-.005v242.3h45.931v-242.3Z",
    transform: "translate(-788.766 -1690.319)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16680",
    "data-name": "Path 16680",
    d: "M1210.922,1951.929a12.134,12.134,0,0,0,.175-1.728,12.3,12.3,0,1,0-24.592,0,12.152,12.152,0,0,0,.174,1.728h-8.2v137.429h40.647V1951.929Z",
    transform: "translate(-819.362 -1778.569)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_17",
    "data-name": "Mask Group 17",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4243",
    "data-name": "Group 4243",
    transform: "translate(0 -17.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4242",
    "data-name": "Group 4242",
    transform: "translate(0 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16565",
    "data-name": "Path 16565",
    d: "M7290.388,4303.252s117.943,50,275.5-43.611,335.646-22.764,420.595,64.5",
    transform: "translate(-7492.375 -4119.272)",
    fill: "none",
    stroke: "#bae5d3",
    strokeWidth: 1,
    opacity: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16566",
    "data-name": "Path 16566",
    d: "M7301.058,4341.356c524.027-502.925,1115.4-100.5,1091.647,349.082",
    transform: "translate(-7842 -4112.639)",
    fill: "none",
    stroke: "#bae5d3",
    strokeWidth: 0.5,
    opacity: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16570",
    "data-name": "Path 16570",
    d: "M7265.66,4268.848c295.727-305.9,738.842-2.958,794.331,155.442",
    transform: "translate(5642.773 7531.62) rotate(-157)",
    fill: "none",
    stroke: "#bae5d3",
    strokeWidth: 0.5,
    opacity: 0.652
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16568",
    "data-name": "Path 16568",
    d: "M7635.8,3906.213C8029.6,3942.605,8182.74,3911.06,8560,4358",
    transform: "translate(9231.55 729.434) rotate(155)",
    fill: "none",
    stroke: "#bae5d3",
    strokeWidth: 0.5,
    opacity: 0.652
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.d60342f307a93e80be9589561b30e4a4.svg";
export { ForwardRef as ReactComponent };